import type { JSX } from 'react'

import { Box, CircularProgress } from '@mui/material'
import { Navigate } from 'react-router-dom'

import { useAuth } from '../../modules/auth/hooks/useAuth'

type ProtectedRouteProps = {
  children: JSX.Element
  role?: string | string[]
}

export function ProtectedRoute({ children, role }: ProtectedRouteProps): JSX.Element {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  const allowedRoles = role ? (Array.isArray(role) ? role : [role]) : null

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />
  }

  return children
}
